import { useHerds } from 'app/agriculture/queries/herds/useHerds';

export function useHerd({ herdId }: { herdId: string }) {
    const herds = useHerds();
    const herd = herds.get(herdId);

    if (!herd) {
        throw new Error(`No herd found for id: ${herdId}`);
    }

    return herd;
}
